/* adjustments / additions to native site outside preact (eg. adding mobile search input) */
const body = document.body;
const desktopInput = document.querySelector('.ExposedSearch__input');
const announceBar = document.querySelector('.js-announce-bar');
const header = document.querySelector('.site-header__primary.js-main-header');

let keydownListenerActive = false;
let searchInput;

export const updateHeaderHeight = () => {
    if (header){
        const hHeight = header.getBoundingClientRect().height;
        document.documentElement.style.setProperty('--ns-header-height', `${hHeight}px`);
    }
    if(announceBar) {
        const aHeight = announceBar.getBoundingClientRect().height;
        document.documentElement.style.setProperty('--ns-abar-height', `${aHeight}px`);
    }
}

const handleSearchKeydown = (event) => {
    if(event.key === 'Escape' || event.key === 'Enter') {
        closeSearchOverlay();
    }
}

export const submitSearch = (event) => {
    const enterEvent = new KeyboardEvent('keydown', {
        key: 'Enter',
        code: 'Enter',
        keyCode: 13,
        which: 13,
        bubbles: true,
        cancelable: true
    });
    event.target.closest('.nosto-autocomplete-wrapper')?.querySelector('input[data-nosto-element="search-input"]')?.dispatchEvent(enterEvent);
}

export const closeSearchOverlay = () => {
    body.classList.remove('ns-search-active');

    if(window.innerWidth < 1024) {
        searchInput?.blur();
        document.body.style.overflow = '';
    }
    document.querySelector('.offcanvas-canvas')?.click(); //hides overlay

    // searchspring:
    document.body.classList.remove('no-scroll-sticky');
    document.getElementById('search-overlay')?.classList?.remove('active');
    document.querySelector('.cg_exposed_search_WS_H3W_ExposedSearch__mobile-input')?.setAttribute('data-active', 'false');

    if (keydownListenerActive) {
        document.removeEventListener('keydown', handleSearchKeydown);
        keydownListenerActive = false;
    }
}

export const openSearchOverlay = () => {
    body.classList.add('ns-search-active');

    if(window.innerWidth < 1024) {
        document.body.style.overflow = 'hidden';
        setTimeout(() => {
            if(document.activeElement === searchInput) return;
            searchInput?.focus();
            searchInput?.click();
        }, 400); // wait transitions
    } else {
        updateHeaderHeight();
        if(document.activeElement !== desktopInput) { 
            desktopInput?.click();
            desktopInput?.focus();
        }
    }
 
    if (!keydownListenerActive) {
        document.addEventListener('keydown', handleSearchKeydown);
        keydownListenerActive = true;
    }
}

export const preinitSearch = (toggleSelector) => {
    //removing unused native elements, for performance and size guide
    [
        '.cg_exposed_search_WS_H3W_ExposedSearch__container', 
        '.collection-size-guide'
    ].forEach(selector => document.querySelectorAll(selector).forEach(el => el.remove()))

    const toggle = document.querySelector(toggleSelector);

    if(!toggle) {
        console.warn('[Nosto helpers.js] Error initializing mobile search. No target or desktop input found.')
        return;
    }

    const searchForm = document.createElement('form');
    searchForm.id = 'nosto-mobile-search-form';
    searchForm.action = '/search';
    searchForm.method = 'GET';
    searchForm.role = "search";

    searchInput = document.createElement('input');
    searchInput.id = 'nosto-mobile-search-input';
    searchInput.type = 'search';
    searchInput.name = 'q';
    searchInput.autocomplete = 'off';
    searchInput.placeholder = "Search"

    const submitBtn = document.createElement('button');
    submitBtn.id = "nosto-mobile-search-submit";
    submitBtn.type = "submit";

    const desktopBackdrop = document.createElement('div');
    desktopBackdrop.classList.add('nosto-search-backdrop');
    desktopBackdrop.role = 'button';
    desktopBackdrop.ariaLabel = 'Close search';

    /* SVG icon */
    const svgNS = "http://www.w3.org/2000/svg";

    const svg = document.createElementNS(svgNS, "svg");
    svg.role = 'presentation';
    svg.ariaHidden = 'true';
    svg.setAttribute("width", "19");
    svg.setAttribute("height", "18");
    svg.setAttribute("viewBox", "0 0 19 18");
    svg.setAttribute("fill", "none");

    const path1 = document.createElementNS(svgNS, "path");
    path1.setAttribute("id", "Vector");
    path1.setAttribute("d", "M6.83254 11.6064L3 15.2373");
    path1.setAttribute("stroke", "#393939");
    path1.setAttribute("stroke-width", "0.672375");

    const path2 = document.createElementNS(svgNS, "path");
    path2.setAttribute("id", "Vector_2");
    path2.setAttribute("d","M10.0263 12.6822C12.8485 12.6822 15.1364 10.5148 15.1364 7.8411C15.1364 5.16743 12.8485 3 10.0263 3C7.20411 3 4.91626 5.16743 4.91626 7.8411C4.91626 10.5148 7.20411 12.6822 10.0263 12.6822Z");
    path2.setAttribute("stroke", "#393939");
    path2.setAttribute("stroke-width", "0.672375");

    svg.appendChild(path1);
    svg.appendChild(path2);

    const srEl = document.createElement('span');
    srEl.classList.add('sr-only', 'visually-hidden');
    srEl.textContent = "Submit search"

    submitBtn.appendChild(svg);
    submitBtn.appendChild(srEl);

    /* ------ adding to DOM ------ */
    searchForm.appendChild(searchInput);
    searchForm.appendChild(submitBtn);

    toggle.parentNode.insertBefore(searchForm, toggle);
    document.getElementById('shopify-section-header')?.after(desktopBackdrop);

    /* ------ events ------ */
    toggle.addEventListener('click', openSearchOverlay);
    desktopInput?.addEventListener('click', openSearchOverlay);
    desktopBackdrop.addEventListener('mouseenter', closeSearchOverlay);
}